import { ReportProfileAlertResourcesBaseModel } from '../report-profile-alert-resources-base-model';

export class ReportProfileAlertDeleteResourceModel extends ReportProfileAlertResourcesBaseModel {
}
